import { Box, Button, ColumnLayout, Container, Header, Link, SpaceBetween } from '@cloudscape-design/components'
import React from 'react'
import { useParams } from 'react-router-dom';
import imageT from "./data/DumpT.jpg"


// Summary component (belum responsive)

const DetailOverview = () => {
  
  return (
    <Container
        
          header={
            <Header variant="h2"
            
          >
              Unit 
            </Header>
          }
          fitHeight={true}
        >
          <ColumnLayout columns={1} variant="text-grid" minColumnWidth={120}>
            
            <div style={{ textAlign: 'center' }}>
              <Box variant="awsui-key-label"></Box>
            <img src={imageT} alt="/" style={{ width: '300px', height: '200px' }}/>
              
              
             
              </div> 
              
        
                 
                 
                 
               
           
            
           
          </ColumnLayout>
        </Container>
  )
}

export default DetailOverview
